import { LS_ANNOUNCEMENTS_DISMISSED } from './constants.js'

/** @returns {Set<number>} */
export function getDismissedAnnouncementIds() {
  try {
    const raw = localStorage.getItem(LS_ANNOUNCEMENTS_DISMISSED)
    if (!raw) return new Set()
    const arr = JSON.parse(raw)
    if (!Array.isArray(arr)) return new Set()
    return new Set(arr.map((id) => Number(id)).filter((id) => Number.isInteger(id) && id > 0))
  } catch {
    return new Set()
  }
}

/** @param {number} id */
export function dismissAnnouncementId(id) {
  const numId = Number(id)
  if (!Number.isInteger(numId) || numId <= 0) return
  const set = getDismissedAnnouncementIds()
  set.add(numId)
  try {
    localStorage.setItem(LS_ANNOUNCEMENTS_DISMISSED, JSON.stringify([...set]))
  } catch {
    /* 无痕模式等无法写入 */
  }
}
